<template>
  <div class="form-check mb-2">
    <label class="form-check-label">
      <input type="checkbox" class="form-check-input" :checked="value" @change="update($event)">{{label}}
    </label>
  </div>
</template>


<script>
export default {
  name: 'CheckBox',
  props: {
    label: String,
    value: Boolean,
  },
  methods: {
    update: function(event){
      this.$emit('change', event.target.checked);
    }
  },
}
</script>
